import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInAppMenuDots = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "More icon",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse",
				cx: 3.00312,
				cy: 10.9992,
				r: 1.8,
				fill: "#121619"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_2",
				cx: 10.0031,
				cy: 10.9992,
				r: 1.8,
				fill: "#121619"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_3",
				cx: 17.0031,
				cy: 10.9992,
				r: 1.8,
				fill: "#121619"
			})
		]
	})
});
export default SvgInAppMenuDots;
